import { useState } from "react";
import { money } from "../../lib/dash";

const Pick = ({ wins, wid, setWid }) => (
  <div className="flex gap-1">
    {wins.map((w) => (
      <button key={w.id} type="button" data-testid={`ads-campaigns-pick-${w.id}`} onClick={() => setWid(w.id)} aria-pressed={wid === w.id}
        className={`rounded-full px-2 py-0.5 text-[10.5px] font-semibold transition-colors ${wid === w.id ? "bg-foreground text-background" : "bg-muted text-muted-foreground hover:text-foreground"}`}>
        {w.id === "today" ? "Today" : w.id === "7d" ? "7 days" : "Month"}
      </button>
    ))}
  </div>
);

export const AdsCampaigns = ({ wins }) => {
  const [wid, setWid] = useState("7d");
  const w = wins.find((x) => x.id === wid) || wins[0];
  return (
    <div className="flex min-h-0 flex-col">
      <div className="flex items-center justify-between gap-2">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.16em] text-muted-foreground">Per campaign</p>
        <Pick wins={wins} wid={w.id} setWid={setWid} />
      </div>
      {w.campaigns.length === 0 ? (
        <p data-testid="ads-campaigns-none" className="mt-2 text-[12px] text-muted-foreground">No campaign spent in this window.</p>
      ) : (
        <ul data-testid="ads-campaigns" className="dash-scroll mt-1 min-h-0 flex-1 overflow-y-auto pr-1">
          {w.campaigns.map((c, i) => (
            <li key={c.id || i} data-testid={`ads-campaign-${i}`} className="border-b border-border/60 py-1.5 last:border-0">
              <div className="flex items-baseline justify-between gap-2">
                <span className="truncate text-[12.5px] font-semibold">{c.name}</span>
                <span className="shrink-0 text-[12.5px] font-semibold tabular-nums">{money(c.spend, w.currency)}</span>
              </div>
              <p className="truncate text-[11px] text-muted-foreground">
                {c.clicks.toLocaleString("en-US")} clicks · {c.cpc == null ? "—" : money(c.cpc, w.currency)} CPC · {c.purchases.count}{" "}
                {c.purchases.type === "omni_purchase" ? "purchases (all channels)" : c.purchases.type ? "purchases (pixel)" : "purchases"}
                {c.attribution ? ` · ${c.attribution}` : ""}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
